import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Type", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Item", -1)
const _hoisted_3 = { class: "invoice-selected-item-description" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Fee or discount", -1)
const _hoisted_5 = { class: "invoice-selected-item-description" }
const _hoisted_6 = {
  key: 3,
  class: "invoice-totals-table"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "invoice-cost-tr" }, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Cost per unit"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Quantity"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-right",
      scope: "col"
    }, "Total cost")
  ])
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "align-right" }
const _hoisted_11 = {
  key: 4,
  class: "invoice-totals-table"
}
const _hoisted_12 = { class: "invoice-cost-tr" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Name", -1)
const _hoisted_14 = { scope: "col" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrSelect = _resolveComponent("NrSelect")!
  const _component_NrFormInput = _resolveComponent("NrFormInput")!
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_NrModal = _resolveComponent("NrModal")!

  return (_openBlock(), _createBlock(_component_NrModal, {
    primaryButtonText: $options.itemModalText,
    secondaryButtonText: "Cancel",
    title: $options.itemModalText,
    hasSecondaryButton: "",
    disableButtons: $options.disableAddLineItemSubmit,
    show: _ctx.activeAddItemModal,
    onOnPrimaryClick: $options.addItem,
    onOnSecondaryClick: $options.closeAddItemModal,
    onOnCloseClick: $options.closeAddItemModal
  }, {
    default: _withCtx(() => [
      _createVNode(_component_NrSelect, {
        modelValue: $options.lineItemType,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($options.lineItemType) = $event)),
        options: $data.itemOptions,
        selectable: $options.setDisabledLineItemTypes,
        clearable: !_ctx.invoiceItemToEdit,
        placeholder: "Select line item type",
        appendToBody: ""
      }, {
        label: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["modelValue", "options", "selectable", "clearable"]),
      ($options.activeLineItemFields)
        ? (_openBlock(), _createBlock(_component_NrSelect, {
            key: 0,
            modelValue: $options.selectedLineItem,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($options.selectedLineItem) = $event)),
            options: $data.lineItemOptions,
            selectable: $options.setDisabledLineItems,
            placeholder: "Select an item",
            "onOption:selected": $options.addLineItem,
            appendToBody: ""
          }, {
            label: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["modelValue", "options", "selectable", "onOption:selected"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.invoiceLineItemForm.selectedLineItem?.description), 1),
      ($options.activeSurchargeFields)
        ? (_openBlock(), _createBlock(_component_NrSelect, {
            key: 1,
            modelValue: $options.selectedSurchargeItem,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($options.selectedSurchargeItem) = $event)),
            options: $data.surchargeItemOptions,
            selectable: $options.setDisabledSurchargeItems,
            placeholder: "Select an item",
            appendToBody: ""
          }, {
            label: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["modelValue", "options", "selectable"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, _toDisplayString($options.selectedSurchargeItem?.description), 1),
      ($options.activeLineItemFields)
        ? (_openBlock(), _createBlock(_component_NrFormInput, {
            key: 2,
            modelValue: $options.lineItemQuantity,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($options.lineItemQuantity) = $event)),
            modelModifiers: { number: true },
            onInput: $options.roundQuantity,
            label: "Quantity",
            type: "number",
            placeholder: "Add quantity",
            required: ""
          }, null, 8, ["modelValue", "onInput"]))
        : _createCommentVNode("", true),
      ($options.activeLineItemFields && _ctx.invoiceLineItemForm.selectedLineItem?.label)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("table", null, [
              _hoisted_7,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  (_ctx.invoiceLineItemForm.selectedLineItem.label?.length > 30)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                        _createVNode(_component_NrTooltip, {
                          label: _ctx.invoiceLineItemForm.selectedLineItem?.label
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($options.truncate(_ctx.invoiceLineItemForm.selectedLineItem?.label, {
                    length: 30
                  })), 1)
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString(_ctx.invoiceLineItemForm.selectedLineItem?.label), 1)),
                  _createElementVNode("td", null, _toDisplayString($options.formatCost(_ctx.invoiceLineItemForm.selectedLineItem?.cost, 3) ||
                '$0.00'), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.invoiceLineItemForm.lineItemQuantity), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString($options.formatCost($options.calculateLineItemCost)), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($options.activeSurchargeFields && $options.selectedSurchargeItem?.label)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("table", null, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("th", _hoisted_14, _toDisplayString($options.surchargeCostType), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  ($options.selectedSurchargeItem.label?.length > 30)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                        _createVNode(_component_NrTooltip, {
                          label: $options.selectedSurchargeItem?.label
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($options.truncate($options.selectedSurchargeItem?.label, { length: 30 })), 1)
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_16, _toDisplayString($options.selectedSurchargeItem?.label), 1)),
                  _createElementVNode("td", null, [
                    ($options.selectedSurchargeItem?.cost_type == 'custom')
                      ? (_openBlock(), _createBlock(_component_NrFormInput, {
                          key: 0,
                          name: "Custom charge",
                          type: "number",
                          class: "invoice-cost-custom-amount",
                          hideLabel: "",
                          placeholder: "Input dollar amount",
                          modelValue: $options.customSurchargeAmount,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($options.customSurchargeAmount) = $event))
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($options.surchargeAmount), 1))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["primaryButtonText", "title", "disableButtons", "show", "onOnPrimaryClick", "onOnSecondaryClick", "onOnCloseClick"]))
}